import { useQuery } from "react-query";
import http from "infra/http";
import URL from "core/resources/urls";

interface useGetListJobsGroupProps {
  page: number;
  size: number;
  name?: string;
  ativo?: boolean;
}

const useGetListJobsGroup = ({
  page,
  size,
  name,
  ativo,
}: useGetListJobsGroupProps) => {
  return useQuery({
    queryKey: [
      URL.RECURRING_JOB_GROUP.OBTER(page, size, name ?? "", ativo ?? false),
    ],
    queryFn: async () => {
      const { data, headers } = await http.get<any, any>(
        URL.RECURRING_JOB_GROUP.OBTER(
          page,
          size,
          name ?? "",
          ativo ?? undefined,
        ),
      );
      return { data, paginate: JSON.parse(headers.paginate) };
    },
    keepPreviousData: true,
  });
};

export default useGetListJobsGroup;
